var log = {
  time: () => {
    var d = new Date();
    return '[' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()) + '] ';
  },
  info: msg => {
    console.groupCollapsed(log.time() + msg);
    console.trace();
    console.groupEnd();
  },
  debug: msg => {
    console.groupCollapsed("%c" + log.time() + msg, "color: #378805");
    console.trace();
    console.groupEnd();
  },
  warn: msg => {
    console.groupCollapsed("%c" + log.time() + msg, "color: #bada55");
    console.trace();
    console.groupEnd();
  },
  error: msg => {
    console.groupCollapsed("%c" + log.time() + msg, "color: #FB7D7D;font-weight:normal;background-color:#280000;");
    console.trace();
    console.groupEnd();
  }
};

export var LoggerVuePlugin = {
  install: function (Vue, options) {
    Vue.prototype.$log = log;
  }
};

export var LoggerVue3Plugin = {
  install: (app, options) => {
    // inject a globally available $log() method
    app.config.globalProperties.$log = log;
  }
};

export default log;


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/log.js
// module id = ABN0
// module chunks = 1 2 3 4 5 6